// AUTO-322: soft, on-brand colours for people and app monograms. The old
// avatars were all navy and read as black next to each other.
export const AVATAR_TONES = [
  { bg: 'linear-gradient(150deg, #EAF6FD 0%, #D3EBF8 100%)', fg: '#0F6392', ring: 'rgba(20, 125, 181, .18)' },
  { bg: 'linear-gradient(150deg, #E9F8F1 0%, #D2EFE2 100%)', fg: '#18704F', ring: 'rgba(27, 122, 90, .18)' },
  { bg: 'linear-gradient(150deg, #EDF4F9 0%, #DCE8F1 100%)', fg: '#1D4A69', ring: 'rgba(16, 47, 69, .14)' },
  { bg: 'linear-gradient(150deg, #FEF5E8 0%, #F8E4C6 100%)', fg: '#8A5614', ring: 'rgba(143, 91, 23, .18)' },
  { bg: 'linear-gradient(150deg, #E8F7FB 0%, #CDEBF5 100%)', fg: '#177FA8', ring: 'rgba(55, 161, 210, .2)' },
  { bg: 'linear-gradient(150deg, #E7F7F6 0%, #CCEDEA 100%)', fg: '#156F6C', ring: 'rgba(21, 111, 108, .18)' },
  { bg: 'linear-gradient(150deg, #FCEEEE 0%, #F5D9D9 100%)', fg: '#9C3C3C', ring: 'rgba(173, 59, 59, .16)' },
  { bg: 'linear-gradient(150deg, #F0F3F6 0%, #DFE6EC 100%)', fg: '#34506A', ring: 'rgba(52, 80, 106, .16)' },
];

export function toneFor(seed = '') {
  const text = String(seed || '');
  let hash = 0;
  for (let index = 0; index < text.length; index += 1) hash = (hash * 31 + text.charCodeAt(index)) >>> 0;
  return AVATAR_TONES[hash % AVATAR_TONES.length];
}

export const initialsOf = (name = '') => String(name).replace(/[^\p{L}\p{N}\s]/gu, ' ').split(/\s+/).filter(Boolean).map((part) => part[0]).join('').slice(0, 2).toUpperCase();
